import "./css/reset.css"
import "./css/colors.css"
import "./css/layout.css"
import "./css/plugins.css"
import "./css/typography.css"
import "./css/utils.css"
import "./css/grid.css"
import "./css/icons.css"
import "./css/buttons.css"
import "./css/forms.css"
import "./css/header.css"
import "./css/footer.css"
import "./css/hero.css"
import "./css/details.css"
import "./css/masonry.css"
import "./css/elements.css"

import "./css/engagement-submenu.css"
import "./css/arguments.css"
import "./css/faq.css"
import "./css/articles.css"
import "./css/cards.css"
import "./css/sharing.css"
import "./css/cookiecontrol.css"
import "./css/gallery.css"

import "./css/admin.css"
import "./css/variables.css"

// import "./fonts/afacad-flux.css"

import { initArguments } from "./js/components/arguments"
import { initFAQ } from "./js/components/faq"
import { initFormHelpers } from "./js/components/formHelpers"
import { initHero } from "./js/components/hero"
import { initNav } from "./js/components/nav"
import { initNewsletterForm } from "./js/components/newsletterForm"
import { initSharingMenu } from "./js/components/sharingMenu"
import { initMasonry } from "./js/lib/masonry"
import { onReady, qsa } from "./js/utils/dom"
// Plausible is enabled via base.html's inline handler; the JS path below is
// left off to avoid double-firing pageviews. See js/utils/plausible.js.
// import { initPlausibleForLanguageSites } from "./js/utils/plausible"
import { initScrollDetection } from "./js/utils/scroll"

window.htmx = require("htmx.org")

onReady(initNav)
onReady(initArguments)
onReady(initSharingMenu)
onReady(initFAQ)
onReady(initHero)
onReady(initMasonry)
onReady(initNewsletterForm)
onReady(initScrollDetection)
// onReady(initPlausibleForLanguageSites)
onReady(initFormHelpers)

onReady(async () => {
  const galleries = qsa(".swiper")
  if (galleries.length) {
    const { renderGallery } = await import(
      /* webpackPrefetch: true */ "./js/components/gallery"
    )
    galleries.forEach(renderGallery)
  }
})

const cl = document.documentElement.classList
cl.remove("no-js")
cl.add("js")
